export const UNIT_LABEL = {
  tsp: "tsp", tbsp: "tbsp", fl_oz: "fl oz", cup: "cups", pint: "pt", quart: "qt", gallon: "gal", ml: "ml", liter: "L",
  oz: "oz", lb: "lb", g: "g", kg: "kg", each: "each", dozen: "doz",
};

export const fmtNum = (n) => (Number.isInteger(n) ? String(n) : Number(n).toFixed(2).replace(/\.?0+$/, ""));

// "6 qt", "60 slices" — count items use the ingredient's own label; small volumes read as cups.
export const fmtQty = (n, unit, countLabel) => {
  if (unit === "quart" && n > 0 && n < 1) return `${fmtNum(n * 4)} cup${n * 4 === 1 ? "" : "s"}`;
  if (unit === "gallon" && n > 0 && n < 1) return `${fmtNum(n * 4)} qt`;
  return `${fmtNum(n)} ${unit === "each" && countLabel ? countLabel : UNIT_LABEL[unit] || unit}`;
};

export const BASIS_LABEL = { half_pan: "per half pan", person: "per person", each: "per each" };

export const todayISO = () => new Date().toLocaleDateString("en-CA");
export const addDaysISO = (iso, d) => {
  const t = new Date(`${iso}T12:00:00`);
  t.setDate(t.getDate() + d);
  return t.toLocaleDateString("en-CA");
};

export const fmtMoney = (n) => (n == null ? "—" : `$${Number(n).toFixed(2)}`);
